// src/App.js
import React from "react";
import Information from "./views/Information";

export default function App() {
  return <Information />;
}
